import {
    EMAIL_CHECK,
    EMAIL_SEND,
    EMAIL_VERIFY_BY_CODE,
    MOBILE_CHECK,
    MOBILE_SEND,
    MOBILE_VERIFY_BY_CODE,
    REGISTER,
    REGISTER_SEARCH,
    USER_2FA_CHECK,
    USER_2FA_MOBILE,
    USER_TOTP_CONFIRM,
    USER_TOTP_REQUEST
} from './endpoints'

/**
 * /register/submit/
 *
 * Create a new user account for a registered customer and authenticate as them
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "customerId": "md023bf9a",
 *     "email": "user@example.com",
 *     "mobileNumber": "01234 567890",
 *     "password": "password1"
 * }
 */
export const register = (request, payload) => {
    try {
        return request.post(REGISTER, payload);
    } catch (e) {
        console.debug(e);
    }
};


/**
 *
 * @param request
 * @param payload = { email: "string" , customerId: "string" }
 * @returns {*}
 */
export  const email_send = (request, payload) => {
    try {
        return request.post(EMAIL_SEND, payload);
    } catch (e) {
        console.debug(e);
    }
}
/**
 *
 * @param request
 * @param payload = { code: "string" }
 * @returns {*}
 */
export const email_verify_code = (request, payload) => {
    payload.code = payload.code.trim();
    try {
        return request.post(EMAIL_VERIFY_BY_CODE, payload);
    } catch (e) {
        console.debug(e);
    }
};
/**
 *
 * @param request
 * @param payload = { email: "string" }
 * @returns {*}
 */
export const email_check = (request, payload) => {
    try {
        return request.post(EMAIL_CHECK, payload);
    } catch (e) {
        console.debug(e);
    }
}



/**
 *
 * @param request
 * @param payload = { mobileNumber: "string" }
 * @returns {*}
 *
 * @example payload = {
 *     "mobileNumber": "+441234321321"
 * }
 */
export const mobile_send= (request, payload) => {
    try {
        return request.post(MOBILE_SEND, payload);
    } catch (e) {
        console.debug(e);
    }
};

/**
 *
 * @param request
 * @param payload = { code: "string" }
 * @returns {*}
 */
export const mobile_verify_code = (request, payload) => {

    payload.code = payload.code.trim();
    try {
        return request.post(MOBILE_VERIFY_BY_CODE, payload);
    } catch (e) {
        console.debug(e);
    }
}

export  const  mobile_check = (request, payload) => {
    try {
        return request.post(MOBILE_CHECK, payload);
    } catch (e) {
        console.debug(e);
    }
}

export const user_2fa = (request, payload) => {
    try {
        return request.get(USER_2FA_CHECK, payload);
    } catch (e) {
        console.debug(e);
    }
}

/**
 *  get the totp secret and qr code
 * @param request
 * @param payload
 * @returns {*}
 */
export const totp_request= (request,payload) => {
    try {
        return request.post(USER_TOTP_REQUEST, payload);
    } catch (e) {
        console.debug(e);
    }
}

/**
 *
 * @param request
 * @param payload = { code: "string" }
 * @returns {*}
 */
export const totp_confirm= (request, payload) => {
    payload.code = payload.code.trim();
    try {
        return request.post(USER_TOTP_CONFIRM, payload);
    } catch (e) {
        console.debug(e);
    }
}

export  const mobile_confirm = (request, payload) => {
    try {
        return request.post(USER_2FA_MOBILE, payload);
    } catch (e) {
        console.debug(e);
    }
}

// export const request_2fa_totp= (request, payload) => {
//     try {
//         return request.post(REGISTER_2FA_TOTP, payload);
//     } catch (e) {
//         console.debug(e);
//     }
//
// }

/**
 * /register/search/
 *
 * Retrieve information for registration using room reservation details
 *
 * @param request
 * @param payload
 * @returns {*}
 *
 * @example payload = {
 *     "email": "string",
 *     "customerNumber": "string",
 *     "unitNumber": "string"
 * }
 */
export const search = (request, payload) => {
    try {
        return request.post(REGISTER_SEARCH, payload);
    } catch (e) {
        console.debug(e);
    }
};
